class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
const parent = document.querySelector('cart-drawer');
        var subtotal = document.querySelector('.cart-drawer__footer .totals__total-value').getAttribute('data-subtotal');
        if(parent && parent.dataset.freeshipAmount){
          parent.calculateProgress(subtotal)
        }
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    const parent = document.querySelector('cart-drawer');
        var subtotal = document.querySelector('.cart-drawer__footer .totals__total-value').getAttribute('data-subtotal');
        if(parent && parent.dataset.freeshipAmount){
          parent.calculateProgress(subtotal)
        }
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.cart_content',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

      connectedCallback() {      
      this.config = JSON.parse(this.querySelector('[free-ship-currency-config ]').value);
        console.log(this.config)

      this.freeShip = parseFloat(this.config[Shopify.country]) ? parseFloat(this.config[Shopify.country]) * 100 : parseFloat(this.config["other"]) ? parseFloat(this.config["other"]) * 100 : false
      console.log(this.freeShip)
      
      this.progressBar = this.querySelector('.cart-shippingThreshold__progress');
      this.progressOuter = this.querySelector('.cart-shipping__numOuter');
      this.successMsg = this.querySelector('.cart-shipping__success');
      const progressHtml = `<span class="cart-shipping__num">${this.formatMoney(this.freeShip * 100)}</span>`;
      //console.log(progressHtml)
        
      this.progressOuter.innerHTML = this.progressOuter.innerHTML.replace(/\[amount\]/g, progressHtml);
    }
    calculateProgress(currentVal) {
      if (!this.freeShip) {
        return;
      }
      this.progressNum = this.querySelector('.cart-shipping__num');
      var result = Math.round((currentVal * 100) / this.freeShip);
      this.progressBar.setAttribute('style', `width: ${result}%; transition-duration: 1s; transition-delay: 0.1s;`);

      var newProgressNum = this.freeShip - currentVal;
      if (newProgressNum <= 0) {
        this.successMsg.style.display = 'block';
        this.progressOuter.style.display = 'none';
        this.progressNum.textContent = this.formatMoney(0);
      } else {
        this.successMsg.style.display = 'none';
        this.progressOuter.style.display = 'block';
        this.progressNum.textContent = this.formatMoney(newProgressNum);;
      }

      if (result >= '100') {
        //$('.cart-shippingThreshold__progress').css('animation', 'none');
        document.querySelector('.cart-shippingThreshold__progress').style.animation = "none";
      } else if (result >= '50') {
        //$('.cart-shippingThreshold__progress').css('animation', '15s linear infinite progress-bar-stripes');
        document.querySelector('.cart-shippingThreshold__progress').style.animation = "15s linear infinite progress-bar-stripes";
      } else {
        //$('.cart-shippingThreshold__progress').css('animation', '10s linear infinite progress-bar-stripes');
        document.querySelector('.cart-shippingThreshold__progress').style.animation = "10s linear infinite progress-bar-stripes";
      }
    }
    defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
    formatWithDelimiters(number, precision, thousands, decimal) {
        precision = this.defaultTo(precision, 2);
        thousands = this.defaultTo(thousands, ',');
        decimal = this.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
    formatMoney(cents) {
      var moneyFormat = moneyForm;
      var superScript = theme && theme.settings && theme.settings.superScriptPrice;
      var format = moneyFormatJson;
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
     
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = this.formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = this.formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = this.formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = this.formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = this.formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart_content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
